import { createContext } from "react"

import IMap from "./IMap"
import NullMap from "./NullMap"

export default createContext<IMap>(new NullMap())
